import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const MyLink = ({ to, children, className, extraFunction }) => {
    const navigate = useNavigate();
    const currentPath = useLocation().pathname;
    const handleClick = () => {
        if ( extraFunction ) {
            extraFunction()
        }
        const element = document.querySelector(`#${to}`);
        if (element) {
            if (currentPath === '/') {
                // navigate(`/?id=${to}`);
                element.scrollIntoView({ behavior: 'smooth', 
                block: 'start',
                inline: 'nearest' });
            } else {
                navigate(`${currentPath}?id=${to}`);
            }
        } else {
            navigate(`/?id=${to}`);
        }
    };

    return (
        <button onClick={handleClick} className={className}>
            {children}
        </button>
    );
}

export default MyLink;